import { render, staticRenderFns } from "./StoreProcessingDetails.vue?vue&type=template&id=5ec13cfc"
import script from "./StoreProcessingDetails.vue?vue&type=script&lang=ts"
export * from "./StoreProcessingDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports